import {Stack, Typography, Link, Box, ListItemText} from "@mui/material";
import React from "react";
import PhoneIcon from "@mui/icons-material/Phone";
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import FormatListBulletedIcon from '@mui/icons-material/FormatListBulleted';
import LanguageHandler from "../translations/LanguageHandler";

const Contact = () => {
    return (
        <Stack direction="column" spacing={4} sx={{p: 3, maxWidth: 600}}>
            <Typography variant="h4" component="h1" fontWeight="medium">
                {LanguageHandler.getTranslatedText("CONTACT")}
            </Typography>

            <Stack direction="row" spacing={2} alignItems="flex-start">
                <InfoOutlineIcon color="primary"/>
                <Typography variant="body1">
                    {LanguageHandler.getTranslatedText("WE_ARE_HERE_TO")}
                </Typography>
            </Stack>

            <Box>
                <Stack direction="row" alignItems="center" spacing={1} sx={{mb: 2}}>
                    <FormatListBulletedIcon color="primary"/>
                    <Typography variant="h6" component="h2">
                        {LanguageHandler.getTranslatedText("PHONE_NUMBERS")}
                    </Typography>
                </Stack>
                <Stack direction="column" spacing={1} pl={4}>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <PhoneIcon fontSize="small" color="action"/>
                        <ListItemText>
                            <Link href="tel:+4074171780" underline="hover" color="text.primary">0741 171 780</Link>
                        </ListItemText>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <PhoneIcon fontSize="small" color="action"/>
                        <ListItemText>
                            <Link href="tel:+40722388217" underline="hover" color="text.primary">0722 388 217</Link>
                        </ListItemText>
                    </Stack>
                    <Stack direction="row" spacing={2} alignItems="center">
                        <PhoneIcon fontSize="small" color="action"/>
                        <ListItemText>
                            <Link href="tel:+40723196303" underline="hover" color="text.primary">0723 196 303</Link>
                        </ListItemText>
                    </Stack>
                </Stack>
            </Box>

            <Box>
                <Stack direction="row" alignItems="center" spacing={1} sx={{mb: 2}}>
                    <MailOutlineIcon color="primary"/>
                    <Typography variant="h6" component="h2">
                        Email
                    </Typography>
                </Stack>
                <Stack direction="row" spacing={2} alignItems="center" pl={4}>
                    <Link href="mailto:atlastravel.brasov@gmail.com" target="_blank" underline="hover">
                        atlastravel.brasov@gmail.com
                    </Link>
                </Stack>
            </Box>
        </Stack>
    );
};

export default Contact;